import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash"

import { 
    Grid,
    Typography,
    FormHelperText,
    FormControl,
    Box,
    TextField,
    CircularProgress,
}  from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import axios from 'axios';

import FileUpload from '../../common/FileUpload';
import DatePicker from '../../common/DatePicker';
import Dialog from '../../common/Dialog';
import InputText, { TextArea } from '../../common/Form';
import Creatable from '../../common/Creatable';
import { Alert, AlertTitle } from '@mui/material';
import { extension } from 'mime-types'

const LABELS_SEPARATOR = ", "

const parseLabelIDs = (raw) => typeof raw === 'string'
    ? raw.split(',').map(id => id.trim()).filter(Boolean)
    : []

class UserSpendingForm extends Component {
    state = { 
        spending_desc: this.props.spending ? this.props.spending.spending_desc : (this.props.spending_demand_desc || ""),
        spending_amount: this.props.spending ? this.props.spending.spending_amount : (this.props.spending_demand_amount || ""),
        spending_amountTTC: this.props.spending ? this.props.spending.spending_amountTTC : (this.props.spending_demand_amountTTC || ""),
        spending_date: this.props.spending ? this.props.spending.spending_date : null,
        spending_files: this.props.spending && Array.isArray(this.props.spending.spending_files)
            ? this.props.spending.spending_files
            : [],
        spending_category: this.props.spending ? this.props.spending.spending_category : "",
        spending_categoryDisplay: this.props.spending && this.props.spending.spending_category ? (() => {
            const cat = this.props.CATEGORIES.CHILD[this.props.spending.spending_category];
            return {
                value: this.props.spending.spending_category,
                label: cat ? `${cat.category_accounting_id} - ${cat.category_name}` : ""
            };
        })() : {value:"", label:""},
        spending_demand: this.props.spending ? this.props.spending.spending_demand : (this.props.spending_demand_id || null),
        // IDs des labels affectés (spending_labels est stocké "id1, id2").
        spending_labels: parseLabelIDs(this.props.spending && this.props.spending.spending_labels),
        open: false,
        isSubmitting: false,
        // Pièces justificatives persistées côté backend (COMPTA-220) — lecture
        // seule ici, la gestion (ajout/suppression) se fait via le formulaire
        // "Compléter" côté admin.
        persistedFiles: [],
        persistedFilesLoading: false,
        persistedFilesError: null,
        errors:{
            spending_desc : "",
            spending_amount : "",
            spending_amountTTC : "",
            spending_date: "",
            spending_category: "",
        },
    }

    componentDidMount = () => {
        // Charger les demandes de dépense si elles ne sont pas déjà chargées
        console.log('UserSpendingForm componentDidMount');
        console.log('SPENDING_DEMANDS:', this.props.SPENDING_DEMANDS);
        console.log('isEmpty(SPENDING_DEMANDS):', isEmpty(this.props.SPENDING_DEMANDS));
        console.log('fetchAdminSpendingsDemand:', this.props.fetchAdminSpendingsDemand);
        console.log('All props keys:', Object.keys(this.props));
        
        if (this.props.fetchAdminSpendingsDemand) {
            if (isEmpty(this.props.SPENDING_DEMANDS)) {
                console.log('Calling fetchAdminSpendingsDemand - SPENDING_DEMANDS is empty');
                this.props.fetchAdminSpendingsDemand();
            } else {
                console.log('Not calling fetchAdminSpendingsDemand - SPENDING_DEMANDS already loaded');
            }
        } else {
            console.log('ERROR: fetchAdminSpendingsDemand is not available in props!');
        }

        // Rechargés à chaque ouverture : les labels dépendent du compte actif,
        // qui peut avoir changé (changement de compte) depuis le dernier fetch.
        if (this.props.fetchLabels) {
            this.props.fetchLabels();
        }

        if (this.props.spending?.spending_id) {
            this.fetchPersistedFiles();
        }
    }

    getLabelOptions = () => {
        const { LABELS } = this.props;
        if (!LABELS || typeof LABELS !== 'object') return [];
        return Object.values(LABELS).filter(item => item && item.label_id);
    }

    handleChangeLabels = (event, selected) => {
        // Les IDs absents des options (labels pas encore chargés) ne sont pas
        // affichés : on les conserve pour ne pas les retirer à l'insu de l'utilisateur.
        const knownIDs = this.getLabelOptions().map(item => item.label_id)
        const hiddenIDs = this.state.spending_labels.filter(id => !knownIDs.includes(id))
        this.setState({
            spending_labels: [...hiddenIDs, ...(selected || []).map(item => item.label_id)],
        })
    }

    fetchPersistedFiles = async () => {
        const spendingId = this.props.spending && this.props.spending.spending_id;
        if (!spendingId) return;
        this.setState({ persistedFilesLoading: true, persistedFilesError: null });
        try {
            const res = await axios.get(`/spendings/${spendingId}/files`);
            const list = Array.isArray(res.data)
                ? res.data
                : (Array.isArray(res.data && res.data.data) ? res.data.data : []);
            this.setState({ persistedFiles: list });
        } catch (err) {
            console.error("fetchPersistedFiles error", err);
            this.setState({ persistedFilesError: "Impossible de charger les pièces justificatives" });
        } finally {
            this.setState({ persistedFilesLoading: false });
        }
    }

    componentDidUpdate = (prevProps) => {
        // Si les SPENDING_DEMANDS viennent d'être chargés, forcer le re-render
        if (isEmpty(prevProps.SPENDING_DEMANDS) && !isEmpty(this.props.SPENDING_DEMANDS)) {
            this.forceUpdate();
        }
        // Si les props spending_demand_* changent après le montage (ex: chargées depuis l'URL), synchroniser le state
        if (!this.props.update && !this.props.spending) {
            const prev = prevProps;
            const curr = this.props;
            const demandPropsChanged =
                prev.spending_demand_id !== curr.spending_demand_id ||
                prev.spending_demand_desc !== curr.spending_demand_desc ||
                prev.spending_demand_amount !== curr.spending_demand_amount ||
                prev.spending_demand_amountTTC !== curr.spending_demand_amountTTC;
            if (demandPropsChanged) {
                this.setState((prevState) => ({
                    spending_desc: curr.spending_demand_desc ?? prevState.spending_desc,
                    spending_amount: curr.spending_demand_amount ?? prevState.spending_amount,
                    spending_amountTTC: curr.spending_demand_amountTTC ?? prevState.spending_amountTTC,
                    spending_demand: curr.spending_demand_id ?? prevState.spending_demand,
                }));
            }
        }
    }

    getSpendingDemandOptions = () => {
        const { SPENDING_DEMANDS } = this.props;

        console.log('getSpendingDemandOptions - SPENDING_DEMANDS:', SPENDING_DEMANDS);
        console.log('getSpendingDemandOptions - isEmpty:', isEmpty(SPENDING_DEMANDS));
        console.log('getSpendingDemandOptions - type:', typeof SPENDING_DEMANDS);
        console.log('getSpendingDemandOptions - keys:', SPENDING_DEMANDS ? Object.keys(SPENDING_DEMANDS) : 'null/undefined');

        if (!SPENDING_DEMANDS || isEmpty(SPENDING_DEMANDS)) {
            console.log('getSpendingDemandOptions - returning empty array');
            return [];
        }

        const ALLOWED_STATUSES = ["VALIDATE", "PAYED", "CREDITED"];
        const sortedDemands = Object.values(SPENDING_DEMANDS)
            .filter(d => ALLOWED_STATUSES.includes(d.spending_demand_status))
            .sort((a, b) => {
                const dateA = new Date(a.spending_demand_date || 0).getTime();
                const dateB = new Date(b.spending_demand_date || 0).getTime();
                return dateB - dateA;
            });
        
        console.log('getSpendingDemandOptions - sortedDemands:', sortedDemands);
        console.log('getSpendingDemandOptions - sortedDemands length:', sortedDemands.length);
        return sortedDemands;
    }

    getSpendingDemandDisplay = (demand) => {
        if (!demand) return "";
        const date = demand.spending_demand_date
            ? new Date(demand.spending_demand_date).toLocaleDateString("fr-FR")
            : "";
        const title = demand.spending_demand_name || demand.spending_demand_desc || demand.spending_demand_reference || demand.spending_demand_id || "";
        const amount = demand.spending_demand_amount !== undefined && demand.spending_demand_amount !== null
            ? `${Number(demand.spending_demand_amount).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`
            : "";
        const result = [date, title, amount].filter(Boolean).join(" - ");
        return result || ""; // S'assurer de toujours retourner une string
    }

    getSpendingDemandOptionById = (spendingDemandId, options = null) => {
        if (!spendingDemandId) return null;
        const list = options || this.getSpendingDemandOptions();
        return list.find(option => option.spending_demand_id === spendingDemandId) || null;
    }

    filterSpendingDemandOptions = (options, { inputValue }) => {
        const terms = inputValue
            ? inputValue.trim().toLowerCase().split(/\s+/).filter(Boolean)
            : [];

        if (!terms.length) {
            return options;
        }

        return options.filter(option => {
            const label = this.getSpendingDemandDisplay(option).toLowerCase();
            return terms.every(term => label.includes(term));
        });
    }

    handleChangeSpendingDemand = (event, newValue) => {
        this.setState({
            spending_demand: newValue ? newValue.spending_demand_id : null
        });
    }
    
    setFiles = (spending_files, error = "") => {
        console.log("[INFO] SET_PHOTO", spending_files);
        this.setState({
            spending_files,
            errors:{
                ...this.state.errors,
                spending_files:error
            }
        })
    }
    // FORM
    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        const regexF = /^([0-9]+([.][0-9]*)?|[.][0-9]+)$/
        const floatFields = [ "spending_amount", "spending_amountTTC" ]
        
        if (!floatFields.includes(name) ){
            this.setState({
                [name]: value
            })
        } else if (floatFields.includes(name) && (regexF.test(value) || value === "")){
            this.setState({
                [name]: value
            })
        }
    }
    handleChangeDate = (spending_date) => {
        console.log('====================================');
        console.log("CHANGE DATE",{spending_date});
        console.log('====================================');
        
        this.setState({            
            spending_date
        })
    }
    handleChangeCat = (option) => {
        if(option){
            this.setState({
                spending_category: option.value || "",
                spending_categoryDisplay: option
            })
        } else {
            this.setState({
                spending_category: "",
                spending_categoryDisplay: {}
            })

        }
    }
    validate = () => {
        let required = [
            "spending_desc", 
            "spending_amount", 
            "spending_amountTTC", 
            "spending_date",
            // "spending_files",
        ]
        let noError = true
        let errors = {}
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ"
            } else {
                errors[field] = ""
            }
        })
        if( isEmpty(this.state.spending_files) ) {
            console.log(`${"spending_files"} is empty`)
            noError =  false
            errors["spending_files"] = "Veuillez remplir ce Champ"
        } else {
            errors["spending_files"] = ""
        }

        // La demande de dépense est obligatoire à la création d'une dépense
        const spendingDemandValue = this.state.spending_demand
        const spendingDemandId = typeof spendingDemandValue === 'string'
            ? spendingDemandValue
            : (spendingDemandValue && spendingDemandValue.spending_demand_id)
        if( !spendingDemandId ) {
            console.log(`spending_demand is empty`)
            noError = false
            errors["spending_demand"] = "Veuillez sélectionner une demande de dépense"
        } else {
            errors["spending_demand"] = ""
        }

        this.setState({
            errors
        })
        return noError
    }
    validateUpdate = () => {
        let required = [
            "spending_desc",
            "spending_amount",
            "spending_amountTTC",
            "spending_date",
        ]
        let noError = true
        let errors = {}
        required.map(field => {
            if( !this.state[field] && isEmpty(this.state[field]) ) { // isEmpty doesn't work on dates, !doesn't work for arrays
                console.log(`${field} is empty`)
                noError =  false
                errors[field] = "Veuillez remplir ce Champ" 
            } else {
                errors[field] = "" 
            }
        })
        // Une dépense existante peut avoir ses pièces déjà persistées côté
        // backend (COMPTA-220) sans nouvel upload dans ce formulaire — le
        // champ requis est alors satisfait par la liste serveur.
        if( isEmpty(this.state.spending_files) && isEmpty(this.state.persistedFiles) ) {
            console.log(`${"spending_files"} is empty`)
            noError =  false
            errors["spending_files"] = "Veuillez remplir ce Champ"
        } else {
            errors["spending_files"] = ""
        }
        this.setState({
            errors
        })
        return noError
    }
    handleSubmit = async () => {

        if( !this.props.update ){

            if( this.validate() ){
                let data = {
                    spending_desc: this.state.spending_desc ,
                    spending_amount: parseFloat(this.state.spending_amount),
                    spending_amountTTC: parseFloat(this.state.spending_amountTTC),
                    spending_rest_to_pay: parseFloat(this.state.spending_amountTTC),
                    spending_total_payed: 0,
                    spending_date: this.state.spending_date,
                    spending_files: this.state.spending_files,
                    spending_category: this.state.spending_category,
                    spending_labels: this.state.spending_labels.join(LABELS_SEPARATOR),
                    spending_update_date: new Date()
                }
                // Inclure spending_demand (doit être un ID string ou null)
                // S'assurer que c'est bien un ID (string) et non un objet
                if (this.state.spending_demand) {
                    data.spending_demand = typeof this.state.spending_demand === 'string' 
                        ? this.state.spending_demand 
                        : (this.state.spending_demand.spending_demand_id || this.state.spending_demand);
                } else {
                    data.spending_demand = null;
                }
                
                console.log('====================================');
                console.log('SUBMIT DATA - spending_demand state:', this.state.spending_demand);
                console.log('SUBMIT DATA - spending_demand type:', typeof this.state.spending_demand);
                console.log('SUBMIT DATA - spending_demand_id prop:', this.props.spending_demand_id);
                console.log('SUBMIT DATA - spending_demand dans data:', data.spending_demand);
                console.log('SUBMIT DATA - full data object:', JSON.stringify(data, null, 2));
                console.log('====================================');
                
                this.setState({ isSubmitting: true })
                try {
                    await this.props.newSpending(data)
                } finally {
                    this.setState({ isSubmitting: false })
                }
                // if NoErrors ...
                console.log('====================================');
                console.log("ERROR", this.props.STATE.spendings );
                console.log('====================================');
                if(this.props.STATE.spendings.error){
                    const errorMessage = typeof this.props.STATE.spendings.error === 'string' 
                        ? this.props.STATE.spendings.error 
                        : 'Un problème est survenu';
                    this.props.notif(true, "error", `Un problème est survenu: ${errorMessage}`)
                } else {
                    this.props.notif(true, "success", "Enregistré")
                    this.props.handleClose()
                    
                }
            } else {
                this.props.notif(true, "error", "Le formulaire contient des erreurs")
            }
        } else {
            if( this.validateUpdate() ){
                let data = this.props.spending
                
                data.spending_desc = this.state.spending_desc 
                data.spending_amount = parseFloat(this.state.spending_amount) 
                data.spending_amountTTC = parseFloat(this.state.spending_amountTTC) 
                data.spending_rest_to_pay = parseFloat(this.state.spending_amountTTC)
                    data.spending_date = this.state.spending_date
                    data.spending_category = this.state.spending_category
                    data.spending_labels = this.state.spending_labels.join(LABELS_SEPARATOR)
                    data.spending_files = Array.isArray(this.state.spending_files)
                        ? this.state.spending_files
                        : (Array.isArray(this.props.spending?.spending_files) ? this.props.spending.spending_files : [])
                    // Mettre à jour spending_demand seulement s'il est défini (peut être null ou une valeur)
                    if (this.state.spending_demand) {
                        data.spending_demand = this.state.spending_demand;
                    } else {
                        data.spending_demand = null;
                    }
                    data.spending_update_date = new Date()
                if (data.spending_status === "WAITING_UPDATE") {
                    data.spending_status = "WAITING_VALIDATION"
                }
                
                console.log('====================================');
                console.log('UPDATE DATA - spending_demand state:', this.state.spending_demand);
                console.log('UPDATE DATA - spending_demand dans data:', data.spending_demand);
                console.log('UPDATE DATA - full data object:', data);
                console.log('====================================');
                
                this.setState({ isSubmitting: true })
                try {
                    await this.props.updateUserSpending(data)
                } finally {
                    this.setState({ isSubmitting: false })
                }
                // if NoErrors ...
                if(this.props.STATE.spendings.error){
                    const errorMessage = typeof this.props.STATE.spendings.error === 'string' 
                        ? this.props.STATE.spendings.error 
                        : 'Un problème est survenu';
                    this.props.notif(true, "error", `Un problème est survenu: ${errorMessage}`)
                } else {
                    this.props.notif(true, "success", "Modifié")
                    this.props.handleClose()
                }
            } else {
                this.props.notif(true, "error", "Le formulaire contient des erreurs")
            }
        }
    }
    
    render() {
        // console.log("New spending PROPS", this.props);
        console.log('==================spending form render==================');
        console.log('props.spending:', this.props.spending);
        console.log('props.spending_demand_id:', this.props.spending_demand_id);
        console.log('props.spending_demand_name:', this.props.spending_demand_name);
        console.log('props.spending_demand_amount:', this.props.spending_demand_amount);
        console.log('props.spending_demand_amountTTC:', this.props.spending_demand_amountTTC);
        console.log('props.spending_demand_desc:', this.props.spending_demand_desc);
        console.log('state.spending_demand:', this.state.spending_demand);
        console.log('state.spending_demand type:', typeof this.state.spending_demand);
        console.log('====================================');
        const { CATEGORIES, spending, spending_demand_name, SPENDING_DEMANDS } = this.props;
        const spendingDemandOptions = this.getSpendingDemandOptions();
        const labelOptions = this.getLabelOptions();
        const isFetchingSpendingDemands = this.props.STATE?.spendingDemands?.fetching || false;
        
        console.log('UserSpendingForm render');
        console.log('SPENDING_DEMANDS prop:', SPENDING_DEMANDS);
        console.log('spendingDemandOptions:', spendingDemandOptions);
        console.log('spendingDemandOptions length:', spendingDemandOptions.length);
        console.log('isFetchingSpendingDemands:', isFetchingSpendingDemands);
        console.log('STATE.spendingDemands:', this.props.STATE?.spendingDemands);
        
        const modalTitle = this.props.update 
            ? "Modifier la Dépense" 
            : (spending_demand_name 
                ? `Ajouter une Dépense - ${spending_demand_name}` 
                : "Ajouter une Dépense");
        return (
            <Dialog
                open={true}
                close={this.props.handleClose}
                title={modalTitle}
                submitAction={this.handleSubmit}
                submitTitle={this.props.update ? "Modifier" : "Créer"}
                disabledSubmit={this.state.isSubmitting}
                fullScreen
                appBar
            >
                <Grid container spacing={2}>
                    {!isEmpty(spending) && spending.spending_status === "WAITING_UPDATE" &&
                        <Grid item xs={12}>
                            <Alert color="error" severity="warning">
                                <AlertTitle>Remarques</AlertTitle>
                                <strong><Typography variant="button">{spending.spending_remarks}</Typography></strong>
                            </Alert>
                        </Grid>
                    }
                    <Grid item sm={6} xs={12}>
                        <DatePicker  
                            id="spending_date" 
                            label="Date de Paiement" 
                            name="spending_date" 
                            value={this.state.spending_date} 
                            handleChange={this.handleChangeDate} 
                            error={this.state.errors.spending_date}
                            required
                        />      
                    </Grid>          
                    <Grid item sm={6} xs={12}>
                        <Creatable
                            label="Catégorie"
                            required={false}
                            error={this.state.errors.spending_category}
                            id="spending_category"
                            options={Object.values(CATEGORIES.CHILD).filter(c => c.is_active !== false).map( item => ({
                                label: `${item.category_accounting_id} - ${item.category_name}`,
                                value: item.category_id
                            }))}
                            value={this.state.spending_categoryDisplay}
                            openPopUp={this.props.admin ? this.props.createNewCategory : null}
                            onChange={this.handleChangeCat}
                        />
                    </Grid>          
                    <Grid item sm={6} xs={12}>
                        <InputText
                            required
                            name="spending_amount" 
                            id="spending_amount" 
                            value={this.state.spending_amount} 
                            label="Montant HT" 
                            placeholder="Montant Hors Taxes" 
                            error={this.state.errors.spending_amount} 
                            onChange={this.handleChange} 
                        />
                    </Grid>          
                    <Grid item sm={6} xs={12}>
                        <InputText
                            required
                            name="spending_amountTTC" 
                            id="spending_amountTTC" 
                            value={this.state.spending_amountTTC} 
                            label="Montant TTC" 
                            placeholder="Montant Toutes Taxes Comprises " 
                            error={this.state.errors.spending_amountTTC} 
                            onChange={this.handleChange} 
                        />
                    </Grid>          
                    <Grid item xs={12}>
                        <TextArea
                            required
                            rows={10}
                            name="spending_desc" 
                            id="spending_desc" 
                            value={this.state.spending_desc} 
                            label="Description" 
                            placeholder="Description de la dépense" 
                            error={this.state.errors.spending_desc} 
                            onChange={this.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            options={spendingDemandOptions}
                            value={this.getSpendingDemandOptionById(this.state.spending_demand, spendingDemandOptions)}
                            onChange={this.handleChangeSpendingDemand}
                            getOptionLabel={(option) => {
                                const label = this.getSpendingDemandDisplay(option);
                                return typeof label === 'string' ? label : '';
                            }}
                            isOptionEqualToValue={(option, value) =>
                                option && value ? option.spending_demand_id === value.spending_demand_id : option === value
                            }
                            filterOptions={this.filterSpendingDemandOptions}
                            noOptionsText={isFetchingSpendingDemands ? "Chargement..." : "Aucune demande correspondante"}
                            loading={isFetchingSpendingDemands}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={this.props.update ? "Demande de dépense" : "Demande de dépense *"}
                                    variant="outlined"
                                    error={!this.props.update && Boolean(this.state.errors.spending_demand)}
                                    helperText={
                                        this.props.update
                                            ? "Champ optionnel"
                                            : (this.state.errors.spending_demand || "Champ obligatoire")
                                    }
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {isFetchingSpendingDemands ? <CircularProgress color="inherit" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />
                            )}
                            clearOnBlur={false}
                            handleHomeEndKeys
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Autocomplete
                            multiple
                            id="spending_labels"
                            options={labelOptions}
                            value={labelOptions.filter(item => this.state.spending_labels.includes(item.label_id))}
                            onChange={this.handleChangeLabels}
                            getOptionLabel={(option) => (option && option.label_name) || ''}
                            isOptionEqualToValue={(option, value) => option.label_id === value.label_id}
                            filterSelectedOptions
                            noOptionsText="Aucun label disponible"
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Labels"
                                    variant="outlined"
                                    helperText="Champ optionnel"
                                />
                            )}
                        />
                    </Grid>
                </Grid>

                {!this.props.update &&
                    <Box>
                        <FileUpload
                            label="Ajouter une Photo"
                            setFiles={this.setFiles} 
                            files={this.state.spending_files || []} 
                        />
                        <FormControl error={!!this.state.errors.spending_files} >
                            <br/>
                            <FormHelperText >{this.state.errors.spending_files}</FormHelperText>
                        </FormControl>
                    </Box>
                }
                {this.props.update && !isEmpty(spending) &&
                    <Box>
                        {/* {!isEmpty(spending.spending_files) &&
                            <Grid container spacing={3}>
                                {spending.spending_files.map( (photo, index) => (
                                    <Fragment>
                                        {photo.filetype === "application/pdf" &&
                                            <Grid key={photo.filename} item xs={6} sm={4} md={3} >
                                                <a href={`/photos/single/${photo.filename}`} download={`fichier${index + 1}.${ extension(photo.filetype) || "pdf"}`}>
                                                    <embed 
                                                        src={`/photos/single/${photo.filename}`} 
                                                        width="100%" 
                                                        height="400px" 
                                                        title={`fichier${index + 1}`} 
                                                        type="application/pdf"
                                                    />
                                                </a>
                                            </Grid>
                                        }

                                        {photo.filetype !== "application/pdf" &&
                                            <Grid key={photo.filename} item xs={6} sm={4} md={3} >
                                                <a href={`/photos/single/${photo.filename}`} download={`fichier${index + 1}.${ extension(photo.filetype) || "jpg"}`}>
                                                    <img 
                                                        src={`/photos/single/${photo.filename}`} 
                                                        title={`fichier${index + 1}`} 
                                                        alt={`fichier${index + 1}`} 
                                                    />
                                                </a>
                                            </Grid>
                                        }
                                    </Fragment>                          
                                    )) }
                                    
                            </Grid>
                        } */}
                        {spending?.spending_id &&
                            <Box mb={2}>
                                <Typography variant="subtitle2">
                                    Pièces justificatives enregistrées
                                </Typography>
                                {this.state.persistedFilesLoading &&
                                    <Typography variant="caption" color="textSecondary">
                                        Chargement…
                                    </Typography>
                                }
                                {this.state.persistedFilesError &&
                                    <Typography variant="caption" color="error">
                                        {this.state.persistedFilesError}
                                    </Typography>
                                }
                                {!this.state.persistedFilesLoading && isEmpty(this.state.persistedFiles) &&
                                    <Typography variant="body2" color="textSecondary">
                                        Aucune pièce jointe
                                    </Typography>
                                }
                                <Grid container spacing={2}>
                                    {this.state.persistedFiles.map((file) => (
                                        <Grid key={file.spf_id} item xs={12} sm={6} md={4}>
                                            <Box style={{ border: "1px solid #e0e0e0", borderRadius: 4, padding: 8 }}>
                                                <Typography variant="body2" noWrap>
                                                    {file.spf_file_name}
                                                </Typography>
                                                <Typography variant="caption" color="textSecondary" noWrap>
                                                    {file.spf_file_type}
                                                </Typography>
                                                <br/>
                                                <a
                                                    href={`/spendings/files/${file.spf_file_id}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    download={file.spf_file_name}
                                                >
                                                    Télécharger
                                                </a>
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        }
                        <FileUpload
                            label="Ajouter une Photo"
                            setFiles={this.setFiles}
                            files={this.state.spending_files || []}
                            saved={spending.spending_files || []}
                        />
                        <FormControl error={!!this.state.errors.spending_files} >
                            <br/>
                            <FormHelperText >{this.state.errors.spending_files}</FormHelperText>
                        </FormControl>
                    </Box>
                }
            </Dialog>
        )
    }
}

export default UserSpendingForm;